module.exports = __webpack_public_path__ + "media/images/demo/portfolio-b1d3650a4e0f5a40d16fb9fd5ce9878d.jpg";